import React from 'react';
import axios from './../../../constants/axios';
import {Button, Table} from 'react-bootstrap';
import {Link} from 'react-router';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import classname from 'classnames';

class SaleHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         sales: [],
         startDate: null,
         endDate: null,
      };
   }


   componentDidMount() {
      axios.get('inventorySales')
         .then((res) => {
            this.setState({
               sales: res.data.results,
               startDate: moment(res.data.startDate),
               endDate: moment(res.data.endDate),
            });
         });
   }

   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   getInvoicesDateBetween = () => {
      const {startDate, endDate} = this.state;
      if (startDate && endDate) {
         axios.get(`inventorySales?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  sales: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };

   render() {
      const {sales} = this.state;
      return (
         <div className="SaleHome">
            <h1>Sales Home</h1>
            <div>
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.startDate}
                  placeholderText="Select Start Date"
                  onChange={this.handleStartDateChange}/>
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.endDate}
                  placeholderText="Select End Date"
                  onChange={this.handleEndDateChange}/>
               <Button onClick={() => this.getInvoicesDateBetween()}>Get Invoices</Button>
            </div>

            <Table>
               <thead>
               <tr>
                  <th>#inv Id</th>
                  <th>Contact Name</th>
                  <th>Amount</th>
                  <th>Prepaid</th>
                  <th>Total Paid</th>
                  <th>Due</th>
                  <th>Submitted</th>
                  <th>Inv Created</th>
                  <th>Order</th>
                  <th>##</th>
               </tr>
               </thead>
               <tbody>
               {sales.map((sale) => (
                  <tr key={sale.id}
                      className={classname({'due_invoice': (sale.due !== 0 && sale.contact_name.includes('Unknown') === false)})}>
                     <td>{sale.id}</td>
                     <td>{sale.contact_name}</td>
                     <td>{sale.total_amount}</td>
                     <td>{sale.prepaid_amount}</td>
                     <td>{sale.paid_amount}</td>
                     <td>{sale.due}</td>
                     <td>{sale.submitted}</td>
                     <td>{sale.created_at}</td>
                     <td>{sale.order_id ? 'Yes' : 'No'}</td>
                     <td>
                        <Link to={`/sale/saleInvoiceDetail/${sale.id}`}>Details</Link>
                     </td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

SaleHome.propTypes = {};

export default SaleHome;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/SaleHome.js
 **/